export class LightBoxStructure {
    constructor() {
        this.dataHookAttribute = 'data-lightBox';
        this.attribute = {
            title: this.dataHookAttribute + '-title',
        };
        this.mainBlock = 'lightBox';
        this.block = {
            close: this.mainBlock + '__close',
            closeChar: '&times;',
            contentWrapper: this.mainBlock + '__content-wrapper',
            content: this.mainBlock + '__content',
            columnWrapper: this.mainBlock + '__col-wrapper',
            column: this.mainBlock + '__col',
            columnActive: this.mainBlock + '__col--active',
            active: this.mainBlock + '__col-wrapper--active',
            img: this.mainBlock + '__img',
            title: this.mainBlock + '__title',
            arrow: {
                prev: this.mainBlock + '__prev',
                next: this.mainBlock + '__next',
                charPrev: '&#10094;',
                charNext: '&#10095;',
            },
        };
    }

    createColumnWrapper(){
        let columnWrapper = document.createElement('div');
        columnWrapper.classList.add(this.block.columnWrapper);

        return columnWrapper;
    }

    createColumn() {
        let column = document.createElement('div');
        column.classList.add(this.block.column);

        return column;
    }

    createImg(element) {
        let img = document.createElement('img');
        img.classList.add(this.block.img);
        img.src = element.getAttribute('href');

        return img;
    }

    createTitle(element) {
        let title = document.createElement('div');
        title.classList.add(this.block.title);
        title.innerHTML = element.getAttribute(this.attribute.title);

        return title;
    }

    createModal(data) {
        const lightBox = document.createElement('div');
        lightBox.classList.add(this.mainBlock);

        const contentWrapper = document.createElement('div');
        contentWrapper.classList.add(this.block.contentWrapper);

        lightBox.appendChild(contentWrapper);

        const close = document.createElement('span');
        close.classList.add(this.block.close);
        close.innerHTML = this.block.closeChar;

        const content = document.createElement('div');
        content.classList.add(this.block.content);

        const prev = document.createElement('a');
        prev.classList.add(this.block.arrow.prev);
        prev.innerHTML = this.block.arrow.charPrev;

        const next = document.createElement('a');
        next.classList.add(this.block.arrow.next);
        next.innerHTML = this.block.arrow.charNext;

        contentWrapper.appendChild(close);
        contentWrapper.appendChild(content);
        contentWrapper.appendChild(prev);
        contentWrapper.appendChild(next);

        data.forEach(element => {
            let columnWrapper = this.createColumnWrapper();
            let column = this.createColumn();
            let img = this.createImg(element);
            let title = this.createTitle(element);


            column.appendChild(img);
            column.appendChild(title);
            columnWrapper.appendChild(column);
            content.appendChild(columnWrapper);
        });

        return lightBox;
    }
}